import { render, staticRenderFns } from "./document-table.vue?vue&type=template&id=ea235b8a&scoped=true"
import script from "./document-table.vue?vue&type=script&setup=true&lang=js"
export * from "./document-table.vue?vue&type=script&setup=true&lang=js"
import style0 from "./document-table.vue?vue&type=style&index=0&id=ea235b8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea235b8a",
  null
  
)

export default component.exports